import React, { useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { setMessage } from "../../../store/slices/Notification";
import { Button, CircularProgress } from "@mui/material";
import { bulkUploader } from "../../../Admin-Dashboard/apiHandler/bulkUploader";
// import { FILE_TYPE } from "./constant";

const FileDownloader: React.FC<{ fileName: string; preferences: string[]; updateTableData: (data: any) => void }> = ({
  fileName,
  preferences,
  updateTableData,
}) => {
  const downloadFile = () => {
    // Get the URL of the file
    const fileUrl = process.env.REACT_APP_PUBLIC_URL + `/csvuploader/${fileName}.csv`;
    // Create a temporary link element to trigger the download
    const link = document.createElement("a");
    link.href = fileUrl;
    link.download = `sample_file_for_${fileName}.csv`;

    // Append the link to the body
    document.body.appendChild(link);

    // Trigger the download
    link.click();

    // Cleanup
    document.body.removeChild(link);
  };

  return <Button onClick={downloadFile}>Download Sample File For {fileName}</Button>;
};

function FileUploader({
  preferences,
  updateTableData,
  updateFixedPreferences,
}: {
  preferences: string[];
  updateTableData: (data: any) => void;
  updateFixedPreferences: CallableFunction;
}) {
  const fileUploaderRrf: any = useRef();
  const [isLoading, updateIsLoading] = useState(false);
  const dispatch = useDispatch();
  const handleOnChange = (e: any) => {
    handleOnSubmit(e.target.files[0]);
  };

  const handleOnSubmit = async (file: any) => {
    try {
      if (!preferences?.length) {
        dispatch(
          setMessage({
            type: "error",
            message: "Add At least 1 preference",
          })
        );
        updateIsLoading(false);
        return;
      }
      updateIsLoading(true);

      const formData: any = new FormData();
      formData.append("mobileCSV", file);
      formData.append("preferences", preferences.join(","));

      const data = await bulkUploader(formData);
      updateTableData(data);
      dispatch(
        setMessage({
          type: "success",
          message: "Bulk upload is uploaded successfully",
        })
      );
      setType("");
      updateFixedPreferences(preferences)
    } catch (err: any) {
      dispatch(
        setMessage({
          type: "error",
          message: err.message,
        })
      );
      setType("");
      // setBncap("");
    } finally {
      if (fileUploaderRrf.current) {
        fileUploaderRrf.current.value = "";
      }
      updateIsLoading(false);
    }
  };
  const [, setType] = React.useState("");

  return (
    <>
      <h1 className="my-12">Bulk Uploader</h1>
      {isLoading ? (
        <div className="flex justify-center py-[15rem]">
          <CircularProgress size={75} />
        </div>
      ) : (
        <>
          <div className="flex items-center" style={{ textAlign: "center" }}>
            <input
              ref={fileUploaderRrf}
              className="hidden"
              type={"file"}
              id={"csvFileInput"}
              accept={".csv"}
              onChange={handleOnChange}
            />
            {/* {type === "variant-safety-security" && (
              <TextField
                type="number"
                value={bncap}
                onChange={(e) => setBncap(e.target.value)}
                label="Bncap"
                variant="outlined"
              />
            )} */}
            <Button
              variant="contained"
              onClick={() => {
                if (fileUploaderRrf.current) {
                  // Programmatically click the button
                  fileUploaderRrf.current.click();
                }
              }}
            >
              Bulk Uploader
            </Button>
          </div>
          <div className="mt-8 flex flex-wrap gap-4">
            <FileDownloader preferences={preferences} updateTableData={updateTableData} fileName={"mobileCsv"} />
          </div>
        </>
      )}
    </>
  );
}

export default FileUploader;
